import React, { useEffect, useState } from 'react'
import "./Cookiebot.css";
import * as translator from "../../utils/translator";
import * as GtmTracker from "../../PixelTrackers/GtmTracker";
import { MainTracker } from '../../PixelTrackers/MainTracker';


const Cookiebot = () => {
  let language = 'de'
  const LANGS = ['de', 'fr', 'en', 'gb']
  LANGS.forEach(element => {

      let url = window.location.href;

      let LANG = new RegExp(`/${element}/|=(${element})`); //const LANG = new RegExp(`/${element}/|(${element})`);

      if (LANG.test(url)){language = element; return}
  });

  if (language === 'gb') language = 'en';

  const save = translator.translate(language, "default", "Cookiebot/modal_save_button");
  const [showOptionsModal, setShowOptionsModal] = useState(false)
  const [createCookie, setCreateCookie] = useState(false)
  const [preferencesConsent, setPreferencesConsent] = useState(true)
  const [statisticsConsent, setStatisticsConsent] = useState(true)
  const [marketingConsent, setMarketingConsent] = useState(true)
  const [allowObject, setAllowObject] = useState({
      functionality: true,
      analytical: true,
      targeting: true
  })
  let customerID
  if (window.eventsTracking.getData("token")){
      customerID = window.eventsTracking.getData("customerID")
  }

  useEffect(() => {
      const params = window.eventsCommon.getFromUrl(window.location.href,'consent');

      if(params && !checkCookieExists('CookieConsent')){
          params[0] === '1' ? setPreferencesConsent('true') : setPreferencesConsent('false')
          params[1] === '1' ? setStatisticsConsent('true') : setStatisticsConsent('false')
          params[2] === '1' ? setMarketingConsent('true') : setMarketingConsent('false')
          setCreateCookie(true)
      }
      else if (!checkCookieExists('CookieConsent')) {
          showCookieBanner()
      }
      else{
          checkCookieAndSendEvents()
      }
  }, [])

  useEffect(() => {
      if(createCookie == true || customerID){
          createCookieConsentCookie()
          checkCookieAndSendEvents() 
      }
  }, [createCookie, customerID])

  const checkCookieExists = (cookieName) => {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          if (cookie.startsWith(cookieName + '=')) {
              return true;
          }
      }
      return false;
  }

  // Maps the current consent state (`allowObject`) to the Mixpanel event
  // property shape defined in HL-9023. "Strictly necessary" is excluded
  // because it is always approved.
  const getCookiePopupEventProps = (buttonLabel) => {
      const anyApproved = allowObject?.functionality || allowObject?.analytical || allowObject?.targeting;
      const consentStatus = anyApproved ? 'approved' : 'not approved';
      return {
          button_label: buttonLabel,
          function: consentStatus,
          analytical_performance: consentStatus,
          targeting: consentStatus,
      };
  }

  const showCookieBanner = () => {
      var cookiebanner = document.getElementById("cookiebanner"),
          isLP = false,
          delay = 0;

      if (isLP) {
          delay = 3000;
      }

      setTimeout(function () {
          cookiebanner.style.display = "block";
      }, delay);
  }

  const hideCookieBanner = () => {
      setTimeout(function () {
          var cookiebanner = document.getElementById("cookiebanner");
          cookiebanner.style.display = "none";
      })
  }

  const createCookieConsentCookie = () => {
      const anyApproved = preferencesConsent || statisticsConsent || marketingConsent;
      const resolvedConsent = anyApproved ? true : false;
      let value = `necessary:true,preferences:${resolvedConsent},statistics:${resolvedConsent},marketing:${resolvedConsent},method:explicit`
      window.eventsStorage.addToCookie('CookieConsent', value ,365);
      window.eventsTracking.track({e:'Cookie Consent Created',p:{'Cookie preferences': resolvedConsent, 'Cookie statistics': resolvedConsent, 'Cookie marketing': resolvedConsent}});

      // Update Google Consent Mode v2
      if (typeof window.setConsent === 'function') {
          window.setConsent({
              necessary: true,
              preferences: resolvedConsent,
              marketing: resolvedConsent,
              analytics: resolvedConsent
          });
      }

      hideCookieBanner()
  }

  const updateAllowObjectField = (field) => {

      let allowObjectCopy = JSON.parse(JSON.stringify(allowObject));
      allowObjectCopy[field] = !allowObjectCopy[field]
      setAllowObject(allowObjectCopy)

      switch (field) {
          case 'functionality':
              setPreferencesConsent(!preferencesConsent)
          break;

          case 'analytical':
              setStatisticsConsent(!statisticsConsent)
          break;

          case 'targeting':
              setMarketingConsent(!marketingConsent)
          break;
      
          default:
              break;
      }
  }

  const checkCookieAndSendEvents = () =>{
      let cookieConsent = window.eventsStorage.getFromCookie('CookieConsent');
      cookieConsent = decodeURIComponent(cookieConsent)

      // Update Google Consent Mode v2 based on existing cookie
      if (typeof window.setConsent === 'function' && cookieConsent) {
          window.setConsent({
              necessary: true,
              preferences: cookieConsent.includes('preferences:true'),
              marketing: cookieConsent.includes('marketing:true'),
              analytics: cookieConsent.includes('statistics:true')
          });
      }

      if (cookieConsent.includes('preferences:true')) {
          // MainTracker.track('custom', 'cookie_consent_preferences')
      }
      if (cookieConsent.includes('statistics:true')) {
          // MainTracker.track('custom', 'cookie_consent_statistics')
      }
      if (cookieConsent.includes('marketing:true')) {
          GtmTracker.track('custom', 'cookie_consent_marketing')
      }
  }

  return (
    <div
      id="cookiebot-container"
      className='top-[30%] bottom-0 left-0 w-full fixed z-[10000] mb-[2%] flex flex-col pointer-events-none'
    >
      <div 
        id="cookiebanner" 
        className="pointer-events-auto max-w-[95vw] md:w-[min(870px,95vw)] mt-auto mx-auto border-[1px] border-solid border-[#e5e7eb] rounded-[16px] bg-white relative" 
        style={ showOptionsModal ? {display:'none' } : { display: 'none' } }
      >
          {
            !showOptionsModal && (
              <div
                id="cookies-first-close-button"
                className="absolute top-[12px] right-[12px] cursor-pointer p-[6px] z-10"
                onClick={() => {
                  MainTracker.track('click', 'Funnel Cookies Popup Click', getCookiePopupEventProps('x'))
                  setCreateCookie(true)
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.71929 0.280712C1.53069 0.0985537 1.27808 -0.00224062 1.01589 3.78026e-05C0.75369 0.00231622 0.502878 0.107486 0.31747 0.292894C0.132062 0.478302 0.0268924 0.729115 0.024614 0.991312C0.0223356 1.25351 0.12313 1.50611 0.305288 1.69471L3.59829 4.98771L0.305288 8.28071C0.209778 8.37296 0.133596 8.4833 0.0811869 8.60531C0.0287779 8.72731 0.00119157 8.85853 3.7757e-05 8.99131C-0.00111606 9.12409 0.0241855 9.25577 0.0744664 9.37866C0.124747 9.50156 0.199 9.61321 0.292893 9.70711C0.386786 9.801 0.498438 9.87525 0.621334 9.92553C0.74423 9.97581 0.87591 10.0011 1.00869 9.99996C1.14147 9.99881 1.27269 9.97122 1.39469 9.91881C1.5167 9.8664 1.62704 9.79022 1.71929 9.69471L5.01229 6.40171L8.30529 9.69471C8.49389 9.87687 8.74649 9.97766 9.00869 9.97539C9.27089 9.97311 9.5217 9.86794 9.70711 9.68253C9.89252 9.49712 9.99768 9.24631 9.99996 8.98411C10.0022 8.72192 9.90145 8.46931 9.71929 8.28071L6.42629 4.98771L9.71929 1.69471C9.90145 1.50611 10.0022 1.25351 9.99996 0.991312C9.99768 0.729115 9.89252 0.478302 9.70711 0.292894C9.5217 0.107486 9.27089 0.00231622 9.00869 3.78026e-05C8.74649 -0.00224062 8.49389 0.0985537 8.30529 0.280712L5.01229 3.57371L1.71929 0.280712Z" fill="#1F2129"/></svg>
              </div>
            )
          }
          {
            !showOptionsModal && (
              <div className="grid md:grid-cols-2 justify-center items-center gap-[40px] p-[24px]">
                <div 
                  id="agreement"
                >
                    <div id="agreement-info">
                      <div id= "cookiebot-title" className="text-[16px] md:text-[22px] font-poppins font-[600] mb-[12px]">{translator.translate(language, "default", "Cookiebot/title")}</div>
                      <div className="text-[14px] font-poppins font-[400]">  
                        {translator.translate(language, "default", "Cookiebot/text")}
                        <a href={translator.translate(language, "default", "Cookiebot/link")} className=" underline ml-[0.5em] text-[#000000]">{translator.translate(language, "default", "Cookiebot/details")}</a>
                      </div>
                    </div>
                </div>
                 
                <div className="grid gap-[18px] md:gap-[24px]">
                  <div>
                    <button 
                      id="btn_accept_cookies"
                      className="cursor-pointer linear-background-color-primary font-header flex items-center justify-center font-medium transition-all duration-300 rounded-[8px] lg:rounded-[16px] text-[14px] lg:text-[22px] leading-none px-[18px] lg:px-8 py-[17px] lg:py-5 bg-primary-green-gradient text-text-on_primary relative overflow-hidden w-full group border-none"
                      onClick={() => {
                          MainTracker.track('click', 'Funnel Cookies Popup Click', getCookiePopupEventProps('Accept all cookies'))
                          setCreateCookie(true)
                          window.eventsTracking.track({e: "Accept All Cookies"})
                      }} 
                    >
                      <span className="absolute inset-0 bg-[#61a333] opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-[8px] lg:rounded-[16px]"></span>
                      <span className="relative z-10 flex items-center justify-center text-white">
                        <span className="text-text-on_primary">{translator.translate(language, "default", "Cookiebot/allow_all")}</span>
                      </span>
                    </button>
                  </div>

                  <div 
                    id="manage-preferences"
                    className="manage-preferences buttons-font-size text-[#61a333] underline text-center cursor-pointer"
                    onClick={() => {
                          MainTracker.track('click', 'Funnel Cookies Popup Click', getCookiePopupEventProps('Manage cookies'))
                          setShowOptionsModal(true);
                          window.eventsTracking.track({e: "Click Cookie Settings"})
                      }}
                  >
                      {translator.translate(language, "default", "Cookiebot/options")}
                  </div>
                </div>
              </div>
            )
          }

      </div>

      {
        showOptionsModal && (
          <div className="pointer-events-auto max-w-[95vw] md:w-[min(870px,95vw)] mt-auto mx-auto border-[1px] border-solid border-[#e5e7eb] rounded-[16px] bg-white grid grid-rows-[auto_1fr_auto] min-h-0">
            <div className="grid grid-cols-[1fr_auto] gap-[30px] justify-between pr-[12px] pt-[12px] pb-[24px] pl-[24px]">
              <div id="title" className="text-[16px] md:text-[22px] font-poppins font-[600]">{translator.translate(language, "default", "Cookiebot/modal_title")}</div>
              <div
                id="cookies-close-button"
                className='cursor-pointer'
                onClick={() => {
                  setShowOptionsModal(false)
                }}
              ><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.71929 0.280712C1.53069 0.0985537 1.27808 -0.00224062 1.01589 3.78026e-05C0.75369 0.00231622 0.502878 0.107486 0.31747 0.292894C0.132062 0.478302 0.0268924 0.729115 0.024614 0.991312C0.0223356 1.25351 0.12313 1.50611 0.305288 1.69471L3.59829 4.98771L0.305288 8.28071C0.209778 8.37296 0.133596 8.4833 0.0811869 8.60531C0.0287779 8.72731 0.00119157 8.85853 3.7757e-05 8.99131C-0.00111606 9.12409 0.0241855 9.25577 0.0744664 9.37866C0.124747 9.50156 0.199 9.61321 0.292893 9.70711C0.386786 9.801 0.498438 9.87525 0.621334 9.92553C0.74423 9.97581 0.87591 10.0011 1.00869 9.99996C1.14147 9.99881 1.27269 9.97122 1.39469 9.91881C1.5167 9.8664 1.62704 9.79022 1.71929 9.69471L5.01229 6.40171L8.30529 9.69471C8.49389 9.87687 8.74649 9.97766 9.00869 9.97539C9.27089 9.97311 9.5217 9.86794 9.70711 9.68253C9.89252 9.49712 9.99768 9.24631 9.99996 8.98411C10.0022 8.72192 9.90145 8.46931 9.71929 8.28071L6.42629 4.98771L9.71929 1.69471C9.90145 1.50611 10.0022 1.25351 9.99996 0.991312C9.99768 0.729115 9.89252 0.478302 9.70711 0.292894C9.5217 0.107486 9.27089 0.00231622 9.00869 3.78026e-05C8.74649 -0.00224062 8.49389 0.0985537 8.30529 0.280712L5.01229 3.57371L1.71929 0.280712Z" fill="#1F2129"/></svg></div>
            </div>
  
            <div className="min-h-0 overflow-y-auto overflow-x-hidden pl-[24px] pr-[12px] mr-[12px] mb-[16px] cursor-pointer">
              <p id="text" className="text-[14px] font-poppins font-[400] text-[#616975] pb-[24px]">{translator.translate(language, "default", "Cookiebot/modal_text")}</p>
            
              <div className="rounded-[16px] overflow-hidden border border-solid border-[#F5F6F7]">
                <table className="w-full table-fixed border-collapse">
                  <tbody>

                    <tr>
                      <th className="break-words [overflow-wrap:anywhere] bg-[#f7faef] text-[#616975] text-[12px] leading-[1.2] font-[400] font-poppins p-[12px] md:w-[25%] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_th_type")}</th>
                      <th className="break-words [overflow-wrap:anywhere] bg-[#f7faef] text-[#616975] text-[12px] leading-[1.2] font-[400] font-poppins p-[12px] md:w-[25%] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_th_allow")}</th>
                      <th className="break-words [overflow-wrap:anywhere] bg-[#f7faef] text-[#616975] text-[12px] leading-[1.2] font-[400] font-poppins p-[12px] md:w-[50%] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_th_explanation")}</th>
                    </tr>
        
                    <tr>
                      <td className="break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] font-poppins border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_type_necessary")}</td>
                      <td className="break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] font-poppins border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_allow_necessary")}</td>
                      <td className="explanation break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] font-poppins border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_explanation_necessary")}</td>
                    </tr>

                    <tr>
                      <td className="break-words [overflow-wrap:anywhere] text-[12px] leading-[1.2] font-[600] p-[12px] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_type_functionality")}</td>
                      <td className="border border-[#F5F6F7] p-[12px]">
                          <label className="custom-checkbox flex gap-[8px]" style={{borderColor: '#e7fcf7'}}>
                              <input className="checkbox allow-checkbox" type="checkbox" data-type="functionality" defaultChecked={true} onChange={() => updateAllowObjectField('functionality')} style={{accentColor: '#269C6E'}} />
                              <span className="checkmark"></span>
                              <span className="checkbox-text text-[12px] leading-[1.2] font-[600]">{translator.translate(language, "default", "Cookiebot/modal_allow_all")}</span>
                          </label>
                      </td>
                      <td className="explanation break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_explanation_functionality")}</td>
                    </tr>

                    <tr>
                      <td className="break-words [overflow-wrap:anywhere] text-[12px] leading-[1.2] font-[600] p-[12px] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_type_analytical")}</td>
                      <td className="border border-[#F5F6F7] p-[12px]">
                          <label className="custom-checkbox flex gap-[8px]" style={{borderColor: '#e7fcf7'}}>
                              <input className="checkbox allow-checkbox" type="checkbox" data-type="analytical" defaultChecked={true} onChange={() => updateAllowObjectField('analytical')} style={{accentColor: '#269C6E'}} />
                              <span className="checkmark"></span>
                              <span className="checkbox-text text-[12px] leading-[1.2] font-[600]">{translator.translate(language, "default", "Cookiebot/modal_allow_all")}</span>
                          </label>
                      </td>
                      <td className="explanation break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_explanation_analytical")}</td>
                    </tr>

                    <tr>
                      <td className="break-words [overflow-wrap:anywhere] text-[12px] leading-[1.2] font-[600] p-[12px] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_type_targeting")}</td>
                      <td className="border border-[#F5F6F7] p-[12px]">
                          <label className="custom-checkbox flex gap-[8px]" style={{borderColor: '#e7fcf7'}}>
                              <input className="checkbox allow-checkbox" type="checkbox" data-type="targeting" defaultChecked={true} onChange={() => updateAllowObjectField('targeting')} style={{accentColor: '#269C6E'}} />
                              <span className="checkmark"></span>
                              <span className="checkbox-text text-[12px] leading-[1.2] font-[600]">{translator.translate(language, "default", "Cookiebot/modal_allow_all")}</span>
                          </label>
                      </td>
                      <td className="explanation break-words [overflow-wrap:anywhere] p-[12px] text-[12px] leading-[1.2] font-[400] border border-[#F5F6F7]">{translator.translate(language, "default", "Cookiebot/modal_explanation_targeting")}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div id='footer-banner-cookies' className='p-[24px] bg-[#f7faef] rounded-b-[16px]'>
              <button 
                className="font-header cursor-pointer flex items-center justify-center font-medium transition-all duration-300 rounded-[8px] lg:rounded-[16px] text-[14px] lg:text-[22px] leading-none px-[18px] lg:px-8 py-[17px] lg:py-5 linear-background-color-primary text-text-on_primary relative overflow-hidden group w-full md:max-w-[345px] md:mx-auto border-none"
                onClick={() => { 
                  MainTracker.track('click', 'Funnel Cookies Popup Click', getCookiePopupEventProps('Save'))
                  setCreateCookie(true)
                  setShowOptionsModal(false)
                  MainTracker.track('click', 'Click Save Cookie Settings')
                }}
              >
                <span className="absolute inset-0 bg-[#61a333] opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-[8px] lg:rounded-[16px]"></span>
                <span className="relative z-10 flex items-center justify-center text-white">
                  <span className="text-white">{save}</span>
                </span>
              </button>
            </div>
          </div>
        )
      }
    </div>

  )
}

export default Cookiebot